import Column from '@components/Column';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import SignUpButton from './components/SignUpButton';
import SignUpForm from './components/SignUpForm';
import SignUpContextProvider from './context/SignUpContextProvider';

interface Params {
    appleId?: string;
    googleId?: string;
    email?: string;
    kakaoId?: number;
    nickname?: string;
    verificationToken?: string;
}

declare module '@stackflow/config' {
    interface Register {
        SignUpActivity: Params;
    }
}

const SignUpActivity: ActivityComponentType<'SignUpActivity'> = ({ params }) => {
    const { t } = useTranslation('signUp');
    const {
        appleId, kakaoId, nickname, googleId, email, verificationToken,
    } = params;
    return (
        <SignUpContextProvider
            appleId={appleId}
            googleId={googleId}
            email={email}
            kakaoId={kakaoId}
            nickname={nickname}
            verificationToken={verificationToken} >
            <AppScreen>
                <Column fullWidth fullHeight>
                    <Header title={t('header')} />
                    <SignUpForm/>
                    <SignUpButton/>
                </Column>
            </AppScreen>
        </SignUpContextProvider>
    );
};

export default SignUpActivity;
